module.exports = __webpack_public_path__ + "TestGenius1.2b197e4974fc566b2b40.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/assets/icon/fonts/TestGenius1.woff?28wm7n
// module id = ../../../../../src/assets/icon/fonts/TestGenius1.woff?28wm7n
// module chunks = styles